module.exports = __webpack_public_path__ + "img/indexBack.21f53591.png";